/*
 * 飞书消息文档 https://open.feishu.cn/document/client-docs/bot-v3/add-custom-bot
 */

import axios from 'axios';
import { isEmpty } from 'lodash';
import { armsErrorSend } from './libs/armsErrorSend';
import { decodeURIDecryptFE } from './libs/JSEncrypt';
import { cache, getUserAccount } from '.';

// 经过后端加密
const user_can_at = {
  'yhq':
    'BrwwkaSmuQO5Mooo2vUAUMGnJOlVbmHqEQ%2FbIaP7oref619wB5HHeMZFIlaofFejlhFWw%2BhoITl5b65SbqZHSJTltAm3v31a2dFAESfpl2toAd%2FRXpAlb5mwmM%2B%2BW2DTWXRsAwQ88dK0NoRzZWb4FZOLiAN08IkcnuDUZ4V8Xn0%3D', // yanghaiqiang
  'ccb':
    'VvKenmWBbB%2BeZVeXUHEJE20oyFUB5kLvggekkIyuxXY94uzUPRsXr4E0yRRcvsdprpwg2dZHdoZbUHYJ67bKDG2pvoXr3kWgQEKw7vK9d7ueHg04Vf7tv%2B276MYSb0rfa5sknGkYqabdDeAPBKj2qBcuFT3ymour8CCSVwH7cEQ%3D', // chencanbin
  'xyx':
    'tSkrgWchi6QBc1LcVUVb%2BGMGsvPcNKiviaDVXlrwNE1X6wKOdcUnNK%2F4WcKc4Gw2UVPRDKr7sQsXTORJEC8ZFYyYpTiWESqklLC4RuskFXh3MITXocER%2B7grZWn0XS42zZFvemL70gESP%2B%2FZXnh0giZiTfUNw%2BLtjddKpfSWOMY%3D', // xieyixuan
  'wyt':
    'EXMawdbk3ImgobyvB%2F8%2FT1j3o%2Bh6t4XhwDJikRUlMI7RXwzLPIW5mbXQwavxfsfrIU1M9Z%2Bo%2BVcl2mUHJwZRugs2OdLcbURdyLrmzh192o0JywaRfV%2BnNtNFRVLJKhXp6Mi8ILa4x81IWOGwQ%2BbS8FeeOaBFBqaOs7aPfkCBME0%3D', // wuyutong
  'hkc':
    'mOkjoQGfr7Jw6CoMexJNauJ3TSPiDA5j73OzJL3QwI2w9K%2FSdMcfwPmXKNzs1OIgvbn3qN7hdp3XjzFeRE4Bg%2FwuNfFjKaInaLkj%2FVOTs1evqC3q5mw06rXgBXvleRvmkeWnvrXSNJxs8bLfL%2FpECKXjJMUb8BxiMIa%2Fr05QQVg%3D', // hekaicong
  'xyk':
    'QOQ00OmsuHimMerzP6yhFjMvYcz7Bx%2F0E9k%2Bm4XxjpwTTb%2BsRU6tlUetLz%2BUIK49OXtIZCXTKUW4iIetP05nxVukX0oJngxOKiuiDXOTMzFNXiUDOdsLvFrtajNqsLEpXW0unm%2BKdTlcxgbJY9EH4E%2Fhoy5HFT1d%2BrcRWGcMVkc%3D', // xueyongkang
  'dxy':
    'NbgovRPFsjhhAyJpJIzAzIaCEIJzT2MBqn+TJ7PhH49d2LoPNiq9pvic2jx6ZhdPEEfcHOni/z7jiUtuwictutGOq3eK610dkDLZXep3eGSf9xjEvuw/Ox13ch5a6N4P8MFe75Iorx9AdSgJFCef0gNKwuT8uKcnafQd/pKkcrY=', // dongxy
  'wxq':
    'RzOQV+uRnDrgBA/q2cFkNey75XGb/yKVS700qhcAMw5IaEaNr+V3aLo81QKBCq4WLsGUKrXrwRVU2re0nvxftrjdf7gOL0BIGCXZmq1c7OkagdBs+pgu8/jNIPeEI9XqCGxK8AYHBQhFQd/yy0gIpMCrG2nRdCwqUo0jVblCKPY=', // wuxq
  'csd':
    'LR2O0INJSSzd7reY18EnQP925kAvi7rYe6heb2+BihABbLKvMGNREEi0ST1M69g/w+poYz5eeNL5rvi5XT1FN68KFtaUywvkpQdOM1s7k3MXpHMS0km8qN+H91XwMBCoIj1LGoehmdKPrJP1Fl0DY7MjHyQ/RHVEBuEONrmaDhs=', // chensd
  'gqy':
    'fv0BeOt2bclpM8ZlC8k7/SAhkjYcLTey0xXtXBEyuq1oqK8OZmAQANyLfIXHnd6Fw1WBYw5SNOPqzJEtFLL0CWpGziZZ79Jf+5l0Mt9ZlwYPBC1LsWH9lHoO166/yaSelTfyzQ+K/x3VYY3EZ4NgnCTDWK0gJcY1RaO/dkudqtE=', // guanqy
};

type UserCanAt = keyof typeof user_can_at;

const webhookConfig = {
  // S.商城前端消息通知【正式环境】
  storeProd: 'https://open.feishu.cn/open-apis/bot/v2/hook/69263e83-84ba-4e45-bc5b-f397ff566c59',
  // S.商城前端消息通知【测试环境】
  storeTest: 'https://open.feishu.cn/open-apis/bot/v2/hook/09bb68dc-94ac-4158-b333-00f11a782611',
  // 评论消息通知群
  reviewRobot: 'https://open.feishu.cn/open-apis/bot/v2/hook/f91947cf-a6da-4506-ad73-2e242aa31516',
  // 商城前端内部消息群
  storeFE: 'https://open.feishu.cn/open-apis/bot/v2/hook/81b2666b-a1c1-4076-9fd1-cbc882c9189c',
  // 临时监控报错群
  track: 'https://open.feishu.cn/open-apis/bot/v2/hook/c67a56a2-22ae-484d-9078-42a71e51b1ac',
};

/** 飞书上报的固定格式，text文本 / at */
type FeishuPostContentFormat =
  | {
      tag: 'text';
      text: string;
    }
  | {
      tag: 'at';
      user_id: string;
    };

type FeishuRobotSendPayload = {
  text: string | string[];
  webhook?: keyof typeof webhookConfig;
  err?: Error;
  at?: UserCanAt | UserCanAt[];
};

/**
 * 飞书消息通知-采用默认格式-页面路径需要自行放在text中
 * @param {String| String[]} text string | string[]
 * @param {Error} err 错误上报，将处理成string类型和堆栈信息，传入err具体信息将同步上报arms查看。
 * @param {String} webhook 飞书群 不传默认发送到 正式 / 测试消息通知群，有at默认发送到前端内部群
 * @param {null|string|string[]} at @ 名字缩写
 */
export const feishuRobotSend = ({ text, webhook, err, at }: FeishuRobotSendPayload) => {
  if (typeof window === 'undefined') return;
  if (window.navigator.userAgent?.includes?.('Googlebot')) return;
  try {
    // local不报错
    if (!window.isProd && !window.location?.protocol.includes('https')) {
      err && console.error(err);
      return console.log('---------飞书消息--------\n', text);
    }

    const title = `【客户端】[${window.__NEXT_DATA__.buildId}] ${window.isCN ? '杭州' : '硅谷'}-${
      window.isProd ? '正式' : `测试`
    }环境推送`;

    const email = getUserAccount('userProfileEmail');
    const guest = getUserAccount('guest');
    const ins_sid = cache?.get?.('_ins_sid'); // 内部会话id，在arms中c1使用。

    const data = {
      'msg_type': 'post',
      'content': {
        'post': {
          'zh_cn': {
            'title': `${title}`,
            'content': [
              [
                {
                  'tag': 'text',
                  'text': `页面路径:  ${window.location.href}`,
                },
              ],
              [
                {
                  'tag': 'text',
                  'text': `时间戳:  ${new Date().valueOf()}`,
                },
              ],
              [
                {
                  'tag': 'text',
                  'text': (email ? `email:  ${email}` : `guest: ${guest}`) + ` - ins_sid: ${ins_sid}`,
                },
              ],
              [
                {
                  'tag': 'text',
                  'text': `country:  ${window.country?.code + '  ' + window.country?.language}`,
                },
              ],
              [
                {
                  'tag': 'text',
                  'text': `UA:  ${window.navigator.userAgent + '  ' + window.navigator.platform}`,
                },
              ],
              [
                {
                  'tag': 'text',
                  'text': `=================`,
                },
              ],
              ...(typeof text === 'string'
                ? [
                    [
                      {
                        'tag': 'text',
                        'text': text,
                      },
                    ],
                  ]
                : text.map((t) => [{ 'tag': 'text', 'text': t }])),
            ] as FeishuPostContentFormat[][],
          },
        },
      },
    };

    if (err) {
      data.content.post.zh_cn.content.push(
        [
          {
            'tag': 'text',
            'text': `=================`,
          },
        ],
        [
          {
            tag: 'text',
            text: `【错误信息】：${err.message} - ${JSON.stringify(err)}`,
          },
        ],
        [
          {
            'tag': 'text',
            'text': `=================`,
          },
        ],
        [
          {
            tag: 'text',
            text: `【堆栈信息】：${err instanceof Error ? err?.stack?.toString?.() : '无'}`,
          },
        ]
      );
    }

    if (at) {
      const _at = Array.isArray(at) ? at : [at];
      data.content.post.zh_cn.content.push(
        ..._at.map((name) => [
          {
            tag: 'at' as const,
            user_id: decodeURIDecryptFE(user_can_at[name]),
          },
        ])
      );
    }

    const group = webhook || (window.isProd ? (!isEmpty(at) ? 'storeFE' : 'storeProd') : 'storeTest');

    axios?.({
      url: webhookConfig[group],
      method: 'post',
      data,
    });

    if (err && err instanceof Error) {
      armsErrorSend(
        err,
        {
          filename: `feishu robot ${Array.isArray(text) ? text[0] : typeof text === 'string' ? text : ''}`,
          data: { text, webhook, at },
        },
        true
      );
    }
  } catch (e) {
    armsErrorSend(e as Error, { filename: 'feishu robot error', data: { text, webhook, err, at } });
  }
};

export default { feishuRobotSend };
